import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { map } from 'lodash';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getCalculatedFieldsState = createSelector(
  getPortalState,
  (state: any) => state.calculatedFields,
);

export const getCalculatedFieldsEntitiesList = createSelector(
  getCalculatedFieldsState,
  state => {
    const calculatedFieldsEntities = state.calculatedFieldsEntities;
    return map(calculatedFieldsEntities, (v, k) => v);
  },
);

export const getCalculatedFieldsLoadedStatus = createSelector(
  getCalculatedFieldsState,
  state => {
    return state.loaded;
  },
);
